import type { AccountHoldersAudienceFilter, AccountHoldersFilters } from '../../../types/features/accountHolders';

const DEFAULT_AUDIENCE_FILTER: AccountHoldersAudienceFilter = 'all_customers';

const DEFAULT_ACCOUNT_HOLDERS_FILTERS: AccountHoldersFilters = {
  search: '',
  audience: DEFAULT_AUDIENCE_FILTER,
};

const validAudienceFilters = new Set<AccountHoldersAudienceFilter>([
  'all_customers',
  'active_customers',
  'trial_customers',
  'leads_with_stores',
  'leads_without_stores',
]);

const parseAudienceFilter = (value: string | null): AccountHoldersAudienceFilter => {
  if (value && validAudienceFilters.has(value as AccountHoldersAudienceFilter)) {
    return value as AccountHoldersAudienceFilter;
  }

  return DEFAULT_AUDIENCE_FILTER;
};

export const getAccountHoldersFiltersFromSearchParams = (
  searchParams: URLSearchParams,
): AccountHoldersFilters => ({
  search: searchParams.get('search') || DEFAULT_ACCOUNT_HOLDERS_FILTERS.search,
  audience: parseAudienceFilter(searchParams.get('audience')),
});

export const buildAccountHoldersSearchParams = (
  filters: AccountHoldersFilters,
): URLSearchParams => {
  const searchParams = new URLSearchParams();
  const trimmedSearch = filters.search.trim();

  if (trimmedSearch) {
    searchParams.set('search', trimmedSearch);
  }

  if (filters.audience !== DEFAULT_AUDIENCE_FILTER) {
    searchParams.set('audience', filters.audience);
  }

  return searchParams;
};
